/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/

import withValidarRecuperar from "HOC/withValidarRecuperar";
import { consumirServicioEncirptacion } from "api";
import { enviar } from "api/funcionesPrueba";
import BreadCrumb from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import DynamicForm from "components/DynamicForm";
import Page from "components/Page";
import { urlGuardarContratantePymes, urlSeccionCargaContratante } from "constants/urls";
import { useNavbarContext } from "contexts/NavbarContext";
import useBuscarColonias from "hooks/useBuscarColonias";
import useBuscarMunicipios from "hooks/useBuscarMunicipios";
import useCustomForm from "hooks/useCustomForm";
import useCustomToast from "hooks/useCustomToasts";
import React, { createContext, useCallback, useEffect, useState } from "react";
import { FormProvider } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { loginAsSuscriptor, logoutAsSuscriptor } from "redux/actions/aLogin";
import { PASOS_BREADCRUMBS } from "utils/constants";
import { isArray, mapArrayDropdownOptions } from "utils/funciones";
import Loading from "wrappers/Loading";
import { dataUsuarioVacio } from "../../../constants";
import { PymesGeneral } from "../constantes/general";
import EmisionFooterBarButtons from "./EmisionFooterBarButtons";
import ModalContratante from "components/ModalMex/ModalContratante";

export const NormativaContext = createContext();

const PymesEmisionContratante = ({ params: { idPoliza }, addWarningToast, history }) => {
  const { removeAllToasts } = useToasts();

  useEffect(() => {
    removeAllToasts();
  }, []);

  const codProducto = "pymesAbiertoInd";

  const methods = useCustomForm({ mode: "onChange" });

  const [catalogo, setCatalogo] = useState(null);
  const [permiteNormativa, setPermiteNoramtiva] = useState(1);
  const [loading, setLoading] = useState(true);
  const { dataUsuario } = useSelector((state) => state.datosUsuarios);
  const municipiosHook = useBuscarMunicipios();
  const { setMunicipios } = municipiosHook;
  const coloniasHook = useBuscarColonias();
  const { setColonias } = coloniasHook;
  const dispatch = useDispatch();
  const { addSuccessToast } = useCustomToast();
  const [estadoNormativa, setEstadoNormativa] = useState({});

  useNavbarContext(PymesGeneral.codigo);

  const init = useCallback(async (reload = false) => {
    setLoading(true);

    const Body = {
      polCodigo: idPoliza,
      prodCodigo: PymesGeneral.prodCodigoCore,
      pasoRevContratante: "obtenerContratante",
      pasoCatContratante: "catalogoContratante",
      formulario: "contratante",
    };

    let res;
    if (PymesGeneral.encriptar.contratante === true) {
      res = await consumirServicioEncirptacion(urlSeccionCargaContratante, Body);
    } else {
      res = await enviar(urlSeccionCargaContratante, Body);
    }
    console.log("RES: ", res);

    if (res?.transaccion && res?.data) {
      const { municipios, colonias, catalogo } = res?.data;

      if (
        !catalogo?.camposAdicionales?.permitirEmitir ||
        catalogo?.camposAdicionales?.superRangoNormativa
      ) {
        if (catalogo?.camposAdicionales?.superRangoNormativa) {
          setPermiteNoramtiva(2);
        }
        !reload &&
          addWarningToast(
            catalogo?.camposAdicionales?.msgError || "No se puede emitir esta póliza",
            {
              autoDismissTimeout: 2500,
            }
          );
      }

      if (catalogo?.DatosContratanteAsegurado) {
        setPermiteNoramtiva(
          catalogo?.DatosContratanteAsegurado?.documentosNormativa?.estadoNormativaCorrecto * 1
        );
        if (
          catalogo?.DatosContratanteAsegurado?.documentosNormativa?.estadoNormativaCorrecto * 1 ===
          1
        ) {
          addSuccessToast("Los documentos enviados son correctos");
          return history.push(`${PymesGeneral.urls.emisionAsegurado}/${idPoliza}`);
        }
        methods.reset(catalogo.DatosContratanteAsegurado);
        setEstadoNormativa({ ...catalogo.DatosContratanteAsegurado?.documentosNormativa });
        if (isArray(municipios)) {
          setMunicipios(municipios?.map(mapArrayDropdownOptions));
        }

        if (isArray(colonias)) {
          setColonias(colonias?.map(mapArrayDropdownOptions));
        }
      }
      setCatalogo(catalogo);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    init();
    if (dataUsuario?.isSuscriptor) {
      if (dataUsuario?.sesionSuscriptor) {
        dispatch(loginAsSuscriptor(dataUsuario?.sesionSuscriptor));
      } else {
        if (dataUsuario?.usu_tipo_usuario !== "usu-suscriptor-sbs") {
          dispatch(logoutAsSuscriptor(dataUsuarioVacio));
        }
      }
      history.push("/");
      addWarningToast("Solo el agente puede continuar con la emisión", {
        autoDismiss: false,
      });
    }
  }, [init]);

  const guardarInformacion = async (data, guardarDatos = true) => {
    setLoading(true);
    const Data = {
      // datosCotizador: {
      prodCodigo: codProducto,
      // cotPasoCodigo: 'contratante',
      // polCodigo: idPoliza,
      idPoliza,
      guardarDatos,
      datosContratanteAsegurado: data,
      // },
    };

    let res;
    if (PymesGeneral.encriptar.contratante) {
      res = await consumirServicioEncirptacion(urlGuardarContratantePymes, Data);
    } else {
      res = await enviar(urlGuardarContratantePymes, Data);
    }

    setLoading(false);
    guardarDatos && init(guardarDatos);

    console.log("RES: ", res);

    return res;
  };

  const onSubmit = async (data) => {
    //const formValues = { ...data }
    if (Object.keys(estadoNormativa).length > 0 && permiteNormativa === 3) {
      const hasErrors = !Object.values(estadoNormativa).some((item) => {
        return item?.estado === false && item?.modificado === true;
      });
      if (hasErrors) {
        addWarningToast("Verique todos los documentos solicitados");
        return;
      }
    }
    delete data?.documentosNormativa;
    const res = await guardarInformacion(data, false);
    if (res?.transaccion === true) {
      if (permiteNormativa !== 1 && catalogo?.camposAdicionales?.superRangoNormativa) {
        await init(true);
        addWarningToast("Se ha enviado un correo al área de normativa para su revisión");
      } else {
        history.push(`${PymesGeneral.urls.emisionAsegurado}/${idPoliza}`);
      }
    }
  };

  const onGuardar = async () => {
    const isValid = await methods.trigger("tipoPersona");
    if (isValid) {
      const data = methods.getValues();
      delete data?.documentosNormativa;
      await guardarInformacion(data);
    } else {
      addWarningToast("Debe seleccionar un tipo de persona");
    }
  };

  const onSubmitError = () => {
    addWarningToast("Rellene el formulario correctamente");
  };

  const onClickAtras = async () => {
    history.push(`${PymesGeneral.urls.facturacion}?idPoliza=${idPoliza}&ramo=pymesAbiertoInd`);
  };

  return (
    <React.Fragment>
      <Loading loading={loading}>
      {catalogo?.DatosContratanteAsegurado && (
                <ModalContratante catalogo={catalogo}/>
            )} 
        <div className='row justify-content-center mx-2'>
          <div className='col-lg-11 col-12'>
            <div className='cr-content'>
              <FormProvider {...methods}>
                <form>
                  <Page styles={{ minHeight: "80vh" }}>
                    <BreadCrumb {...PASOS_BREADCRUMBS[codProducto].breadCrumb} showPaths={false} />

                    <BreadCrumbPasosV2
                      {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasosEmision[1]}
                      pasos={PASOS_BREADCRUMBS[codProducto].pasosEmision}
                    />

                    <NormativaContext.Provider value={{ setEstadoNormativa, estadoNormativa }}>
                      <DynamicForm {...catalogo?.validaciones} resources={catalogo} />
                    </NormativaContext.Provider>
                  </Page>
                </form>
              </FormProvider>

              <EmisionFooterBarButtons
                onClickAtras={onClickAtras}
                labelAtras={'Atras'}
                onClickGuardar={onGuardar}
                onClickContinuar={methods.handleSubmit(onSubmit, onSubmitError)}
              />
            </div>
          </div>
        </div>
      </Loading>
    </React.Fragment>
  );
};

export default withValidarRecuperar(PymesEmisionContratante);
